module.exports = __webpack_public_path__ + "static/media/houchengxi.481820b9.png";